module.exports = __webpack_public_path__ + "static/img/VENICE_MAPLE.512486f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/VENICE_MAPLE.jpg
// module id = mQ3x
// module chunks = 0